import { get } from 'api';

import { LOAD_SERVICES, RESET_SERVICES, SERVICES_LOADED, SYNC_FAILED } from './actionTypes';
import type { IAgronomyAgreementServicesActions } from './types';

export const initialActionsState: IAgronomyAgreementServicesActions = {
  loadServices: () => {},
  resetServices: () => {},
};

export const getActions = (dispatch: (value: { type: string; payload?: any }) => void) => ({
  loadServices: async () => {
    dispatch({ type: LOAD_SERVICES });

    const { data, error } = await get('/agronomy-agreements/additional-services');

    if (error) {
      dispatch({ type: SYNC_FAILED, payload: error });
    } else {
      dispatch({ type: SERVICES_LOADED, payload: { data: Array.isArray(data) ? data : [] } });
    }
  },

  resetServices: () => dispatch({ type: RESET_SERVICES }),
});
